import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Newspaper, FileText, Building2, Users,
  Settings, LogOut, Menu, X, ChevronRight, HeartPulse,
  Image, Globe, Wrench, Navigation
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './AdminLayout.css';

const navItems = [
  { to: '/admin',               icon: LayoutDashboard, label: 'Dashboard',        exact: true },
  { to: '/admin/slider',        icon: Image,           label: 'Slider' },
  { to: '/admin/lajmet',        icon: Newspaper,       label: 'Lajmet' },
  { to: '/admin/publikimet',    icon: FileText,        label: 'Publikimet' },
  { to: '/admin/departamentet', icon: Building2,       label: 'Departamentet',    roles: ['superadmin','admin'] },
  { to: '/admin/sherbimet',     icon: Wrench,          label: 'Shërbimet',        roles: ['superadmin','admin'] },
  { to: '/admin/udheheqja',     icon: Users,           label: 'Punonjësit',       roles: ['superadmin','admin'] },
  { to: '/admin/faqet',         icon: Globe,           label: 'Faqet' },
  { to: '/admin/perdoruesit',   icon: Users,           label: 'Përdoruesit',      roles: ['superadmin','admin'] },
  { to: '/admin/cilesimet',     icon: Settings,        label: 'Cilësimet',        roles: ['superadmin','admin'] },
  { to: '/admin/menyja',         icon: Navigation,      label: 'Menyja',           roles: ['superadmin','admin'] },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const visible = navItems.filter(i => !i.roles || i.roles.includes(user?.role));

  const roleColor = { superadmin: '#FFD166', admin: '#a8edca', editor: '#b0c9e8' };

  return (
    <div className="admin-shell">
      {/* Mobile topbar */}
      <div className="admin-topbar">
        <button onClick={() => setOpen(v => !v)} className="hamburger">
          {open ? <X size={20}/> : <Menu size={20}/>}
        </button>
        <span className="admin-topbar-title">Admin Panel</span>
        <span className="admin-topbar-user">{user?.name}</span>
      </div>

      {/* Sidebar */}
      <aside className={`admin-sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-brand" onClick={() => { navigate('/admin'); setOpen(false); }}>
          <div className="sidebar-brand-icon"><HeartPulse size={18}/></div>
          <div>
            <p className="sidebar-brand-name">Spitali</p>
            <p className="sidebar-brand-sub">Admin Panel</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          {visible.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={() => setOpen(false)}
            >
              <item.icon size={16} className="sidebar-link-icon"/>
              <span>{item.label}</span>
              <ChevronRight size={13} className="sidebar-link-arrow"/>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-bottom">
          <div className="sidebar-user">
            <div className="sidebar-user-avatar">
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div className="sidebar-user-info">
              <p className="sidebar-user-name">{user?.name}</p>
              <p className="sidebar-user-role" style={{color: roleColor[user?.role] || '#b0c9e8'}}>
                {user?.role}
              </p>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>
            <LogOut size={15}/> Dil
          </button>
        </div>
      </aside>

      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)}/>}
      <main className="admin-content">{children}</main>
    </div>
  );
}
